/* Progressive enhancement: native Shopify forms remain usable without JS. */
(() => {
  const setButtonLabel = (button, text) => {
    button.querySelectorAll('[data-button-label]').forEach(label => { label.textContent = text; });
  };
  const init = (root = document) => {
    root.querySelectorAll('[data-menu]').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      menu.addEventListener('click', event => { if (event.target.closest('a')) menu.open = false; });
      menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
    });
    root.querySelectorAll('[data-product-form]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const select = form.querySelector('[name="id"]');
      const button = form.querySelector('[type="submit"]');
      const region = form.closest('[data-product]');
      const feedback = form.querySelector('[data-feedback]');
      const update = () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        setButtonLabel(button, available ? 'Add to cart' : 'Sold out');
        region.querySelector('[data-price]').textContent = option.dataset.price;
        const compare = region.querySelector('[data-compare]');
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
        region.querySelector('[data-stock]').textContent = available ? 'Available' : 'This option is sold out';
        const quantity = form.querySelector('[name="quantity"]');
        quantity.min = option.dataset.min || '1';
        quantity.step = option.dataset.step || '1';
        if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
        quantity.value = quantity.min;
        if (select.value) { const url = new URL(location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url); }
      };
      select.addEventListener('change', update);
      form.addEventListener('submit', async event => {
        if (!window.fetch || !form.checkValidity()) return;
        event.preventDefault();
        if (form.dataset.busy) return;
        form.dataset.busy = 'true';
        button.disabled = true; setButtonLabel(button, 'Adding…');
        feedback.textContent = ''; feedback.className = 'form-feedback';
        try {
          const response = await fetch(form.dataset.addUrl, {method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'This item could not be added. Please try again.');
          feedback.classList.add('success');
          feedback.append(document.createTextNode('Added to your cart: ' + result.product_title + (result.variant_title && result.variant_title !== 'Default Title' ? ' — ' + result.variant_title : '') + '. '));
          const link = document.createElement('a'); link.href = form.dataset.cartUrl; link.textContent = 'View cart →'; feedback.append(link);
          try {
            const cart = await (await fetch(form.dataset.cartUrl + '.js', {headers:{'Accept':'application/json'}})).json();
            document.querySelectorAll('[data-cart-count]').forEach(el => {
              el.textContent = cart.item_count;
              el.hidden = cart.item_count === 0;
            });
            document.querySelectorAll('[data-cart-link]').forEach(el => {
              el.setAttribute('aria-label', 'Shopping cart, ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items'));
            });
          } catch { /* Receipt stays valid if the count refresh fails. */ }
        } catch (error) { feedback.classList.add('error'); feedback.textContent = error.message || 'Unable to add this item. Please try again.'; }
        finally { delete form.dataset.busy; button.disabled = select.selectedOptions[0].dataset.available !== 'true'; setButtonLabel(button, button.disabled ? 'Sold out' : 'Add to cart'); }
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
